import { trim } from 'ramda'

// Helper to find a profile by name in mutation response
export const getProfileByName = (res, profileName) => {
  return res?.data?.profile?.profiles.find(profile => profile?.name === trim(profileName))
}
